// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__d9GdY","title":"Header_title__3WzY8","side":"Header_side__26fQ9"};